/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

export const ALERT_CHECKBOX_FORM_NAME = 'saveSearch'
export const TOOLTIP_TEXT =
  'We’ll find the highest ranked, most similar properties (up to 3) and automatically message them for you one time. You’ll also be the first to receive updates on other similar properties as they become available.'
export const TOOLTIP_TEXT_MM_PREVENT =
  'You’ll be the first to receive updates on similar properties as they become available.'
export const DLC_CHECKBOX_TEXT =
  'Contact similar properties on my behalf. I consent (not a condition of purchase) to be called and texted by the top matched similar properties.'
export const MM_PREVENT_CHECKBOX_TEXT = 'Notify me about similar properties'
